import { FC } from "react";
import { Link } from "react-router-dom";

import ArrowRightIcon from "web/assets/icons/arrow-right.svg";

import { GA_GTM_CATEGORY_CLICK_ACTIONS } from "web/utils/system/GTM/sendGaGtmEvent";
import {
  trackCategoryClick,
  trackCategoryExpand,
} from "web/utils/system/GTM/navigationGtmEvents";

import classes from "./list.scss";
import { CategoryListItemData } from "./utils/types";

interface ICategoryListItemProps {
  category: CategoryListItemData;
  onClick: () => void;
  parentLabel?: string;
}

const getCategoryClickLabel = (parentLabel: string | undefined, name: string) =>
  parentLabel ? `${parentLabel} / ${name}` : name;

const CategoryListItem: FC<ICategoryListItemProps> = ({
  category,
  onClick,
  parentLabel,
}) => {
  const content = (
    <>
      <span>{category.name}</span>
      <ArrowRightIcon width={10} />
    </>
  );

  if (category.hasSubcategory) {
    return (
      <button
        type="button"
        className={classes.navItem}
        onClick={() => {
          trackCategoryExpand(category.name);
          onClick();
        }}
      >
        {content}
      </button>
    );
  }

  return (
    <Link
      className={classes.navItem}
      to={category.redirectUrl}
      onClick={() => {
        trackCategoryClick(
          GA_GTM_CATEGORY_CLICK_ACTIONS.MOBILE,
          getCategoryClickLabel(parentLabel, category.name)
        );
        onClick();
      }}
    >
      {content}
    </Link>
  );
};

export default CategoryListItem;
